import React from 'react'
import DomParser from 'dom-parser'


const RichText = ({ children, tag: Tag = 'span', ...props }) => (
    <Tag {...props} dangerouslySetInnerHTML={{
        __html: children
    }} />
)

export const summariseRichText = text => Array.from(
        new DomParser()
            .parseFromString(text)
            .getElementsByTagName('p')
    )
    .map(p => p.innerText)
    .join(". ")

export default RichText
